import alertify from 'alertifyjs';

alertify.defaults.closable = false;
alertify.defaults.movable = false;
alertify.defaults.transition = 'fade';
alertify.defaults.notifier.position = 'top-right';
alertify.defaults.glossary.title = 'ご確認ください';
alertify.defaults.glossary.ok = 'OK';
alertify.defaults.glossary.cancel = 'キャンセル';

export default alertify;
